import { configureStore } from '@reduxjs/toolkit'
import Reactotron from '../ReactotronConfig'
import { DialVerseApi } from '../app/api'
import AuthReducer from './auth.slice'
import UserReducer from './user.slice'
import WebSocketReducer from './websocket.slice'

export const store = configureStore({
  reducer: {
    user: UserReducer,
    auth: AuthReducer,
    websocket: WebSocketReducer,
    [DialVerseApi.reducerPath]: DialVerseApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(DialVerseApi.middleware),
  ...(process.env.NODE_ENV === 'development'
    ? {
        enhancers: (getDefaultEnhancers) =>
          getDefaultEnhancers().concat(Reactotron.createEnhancer()),
      }
    : {}),
})
